import { AutocompleteValue, Autocomplete, TextField } from "@mui/material";
import { useCallback } from "react";
import { useGetProductsQuery } from "src/api/services/productsApi";
import { Product } from "src/api/types";

type Props<Multiple extends boolean, T> = {
  required?: boolean;
  multiple?: Multiple;
  value: Multiple extends true ? T[] : T | null;
  onChange: (value: Multiple extends true ? T[] : T | null) => void;
  select: (p: Product) => T;
};

function ProductsSelect<
  T extends Pick<Product, "name" | "id">,
  Multiple extends boolean = false,
>({ multiple, value, onChange, select, required = false }: Props<Multiple, T>) {
  const { data } = useGetProductsQuery(undefined, {
    selectFromResult: ({ data }) => {
      return {
        data: (data?.data ?? []).map(select),
      };
    },
  });

  const handleProduct = useCallback(
    (
      _: React.SyntheticEvent<Element, Event>,
      value: AutocompleteValue<T, Multiple, false, false>,
    ) => {
      onChange(value);
    },
    [onChange],
  );

  return (
    <Autocomplete<T, Multiple, false, false>
      aria-required={required}
      multiple={multiple}
      options={data}
      getOptionLabel={(p) => p.name}
      value={value}
      onChange={handleProduct}
      renderInput={(params) => <TextField {...params} label="Product" />}
    />
  );
}

export default ProductsSelect;
